import { Tooltip, TooltipContent, TooltipTrigger } from "@shared/ui/tooltip";
import { HelpCircle } from "lucide-react";
import React from "react";

type ValueLabelProps = {
  label?: string | null;
  value?: string | null;
  description?: string | null;
  layout?: "vertical" | "horizontal";
  className?: string;
  tooltip?: string;
};

export const ValueLabel: React.FC<ValueLabelProps> = ({
  label,
  value,
  description,
  layout = "vertical",
  className = "",
  tooltip,
}) => {
  const baseClasses =
    layout === "horizontal"
      ? "flex items-center gap-2"
      : "flex flex-col gap-0.5";

  return (
    <div className={`${baseClasses} ${className}`}>
      <div className="flex items-center gap-1">
        <p className="text-xs text-muted-foreground tracking-wide">
          {label ?? "NA"}
        </p>
        {tooltip && (
          <Tooltip>
            <TooltipTrigger asChild>
              <HelpCircle className="h-3.5 w-3.5 text-gray-400" />
            </TooltipTrigger>
            <TooltipContent>
              <p className="max-w-xs">{tooltip}</p>
            </TooltipContent>
          </Tooltip>
        )}
      </div>
      <p className="text-sm font-medium text-foreground">{value ?? "NA"}</p>
      {description && (
        <p className="text-xs text-muted-foreground">{description}</p>
      )}
    </div>
  );
};
